<app-discount-advanced [discount]="discount"></app-discount-advanced>
